/**
 * Get a social network share link
 *
 * @param {string} network - the social network id
 * @returns {string} the url
 */
const getSocialNetworkShareLink = network => {
  const url = window.location.href

  if (network === 'twitter') {
    return `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`
  }

  if (network === 'facebook') {
    return `https://www.facebook.com/sharer.php?u=${encodeURIComponent(url)}`
  }

  if (network === 'linkedin') {
    return `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
      url
    )}`
  }

  return url
}

export default getSocialNetworkShareLink
